__turbopack_context__.v({
  "flair": "MouseTracker-module__UY6aVa__flair",
});
